export const productCategoryDefaultValues = {};
